import { render } from "./TransitionFade.vue?vue&type=template&id=816291c6&scoped=true&ts=true"
import script from "./TransitionFade.vue?vue&type=script&lang=ts"
export * from "./TransitionFade.vue?vue&type=script&lang=ts"

import "./TransitionFade.vue?vue&type=style&index=0&id=816291c6&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-816291c6"]])

export default __exports__